import { tick, cross } from "../../assets/icons";

const CIRCLE_SIZE = 18;

function BooleanStatusIcon({ value, trueLabel, falseLabel }) {
  if (value == null) return <span>-</span>;

  const label = value ? trueLabel : falseLabel;

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      style={{
        width: CIRCLE_SIZE,
        height: CIRCLE_SIZE,
        borderRadius: "50%",
        background: value ? "var(--surface-success)" : "var(--surface-error)",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <img
        src={value ? tick : cross}
        alt=""
        style={value ? { width: 10, height: 8 } : { width: 9, height: 9 }}
        draggable={false}
      />
    </span>
  );
}

export default BooleanStatusIcon;
